import { getCookie, setCookie } from 'utils/cookies';
import { COOKIE_KEYS, STORAGE_KEYS } from 'utils/constants/constants';
import { ERoutePaths } from 'types/routes/enums';

export const setTokens = ({ idToken, accessToken, refreshToken }) => {
  const isRememberSession = JSON.parse(localStorage.getItem(STORAGE_KEYS.rememberSession) || 'true');
  const hours = isRememberSession ? 720 : 1;

  setCookie(COOKIE_KEYS.idToken, idToken, ERoutePaths.Root, hours);
  setCookie(COOKIE_KEYS.accessToken, accessToken, ERoutePaths.Root, hours);
  setCookie(COOKIE_KEYS.refreshToken, refreshToken, ERoutePaths.Root, hours);
};

export const getTokens = () => ({
  idToken: getCookie(COOKIE_KEYS.idToken),
  accessToken: getCookie(COOKIE_KEYS.accessToken),
  refreshToken: getCookie(COOKIE_KEYS.refreshToken),
});
